const plant_collections = [
  {
    id: 1,
    name: "Cute Succulents & Cacti",
    image: require("../images/SUCCULANTS.jpg"),
    new_price: 439,
    old_price: 589,
  },
  {
    id: 2,
    name: "Tropical Blooms",
    image: require("../images/tropical.jpg"),
    new_price: 549,
    old_price: 699,
  },
  {
    id: 3,
    name: "Herb Garden Starters",
    image: require("../images/herbs.jpg"),
    new_price: 299,
    old_price: 399,
  },
  {
    id: 4,
    name: "Low-Light Houseplants",
    image: require("../images/infroor house plants.jpg"),
    new_price: 349,
    old_price: 449,
  },
];

export default plant_collections;